import React from 'react';
import { Text, Img, Button, Checkbox, Icon } from '../../Atoms';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Modal } from '../../Molecules';
// TemplateHome.module.scss
import styles from './../../Templates/TemplateHome/TemplateHome.module.scss';
function OrganismCarteTp(props) {
  const renderErrorModalContent = () => {
    return (
      <div style={{ height: '100%' }}>
        <div
          className={styles['medadom-modal-close-container']}
        >
          <button
            className={styles['medadom-modal-close-btn']}
            onClick={props.onCloseErrorModal}
          >
            <Icon
              icon="CloseIcon"
              size={20}
              color="#000"
              className={styles['medadom-modal-close-icon']}
            />
          </button>
        </div>
        <div style={{ padding: '0px 20px' }}>
          <h3>Oups !</h3>
          <div>
            Il semblerait que nous rencontrions un problème. Nous sommes en train de le résoudre et nous serons opérationnels très prochainement!
          </div>
          <br/>
          <div>
            En attendant, si vous avez besoin de l'aide de nos équipes concernant votre contrat, vous pouvez nous contacter à gestion@spvie.com
          </div>
          <br/>
          <div>Merci pour votre patience !</div>
        </div>
      </div>
    );
  };
  return (
    <div className='cartetp-organism-container pb-40'>
      <Modal
        show={props.showErrorModalOpen}
        onHide={props.onCloseErrorModal}
        dialogClassName={styles['medadom-modal-container']}
        contentClassName={styles['medadom-modal']}
        showIconClose={false}
      >
        {renderErrorModalContent()}
      </Modal>
      <Row className='cartetp-organism-row'>
        <Col lg={{ span: 6, order: 2 }} className='cartetp-organism-col'>
          <div className='cartetp-organism-img-container'>
            <div className='cartetp-organism-img-2' />
          </div>
        </Col>
        <Col lg={6} className='cartetp-organism-col'>
          <div className='cartetp-organism-content'>
            <div className='cartetp-organism-smartphone-container'>
              <Text
                text='Ajouter sur votre smartphone'
                className='cartetp-organism-smartphone-text'
              />
              <div className='cartetp-organism-smartphone-img-container'>
                <div
                  className="cartetp-organism-smartphone-img-apple"
                  onClick={() => props.addPassToWallet(0)}
                />
                <div
                  className="cartetp-organism-smartphone-img-google"
                  onClick={() => props.addPassToWallet(1)}
                />
              </div>
              {props.addPassInProgress ? (
                <Text text={<strong>Ajout en cours. Veuillez patientez ...</strong>} />
              ) : null}
            </div>
            <Text
              text={`${props.civility} ${props.firstName} ${props.lastName}`}
              type='h4'
              className='cartetp-header-container cartetp-header-font'
            />
            <Text
              text={`Numéro de Sécurité Sociale : ${props.socialSecurityNumber}`}
              type='h5'
              className='cartetp-header-container'
            />
            <Text
              text={`Numéro d'adhérent : ${props.adherentNumber}`}
              type='h5'
              className='cartetp-header-container'
            />
            {/* <Text
              className="cartetp-header-container"
              text={
                <>
                  Validité du <strong>{props.startDateValidity}</strong> au <strong>{props.endDateValidity}</strong>
                </>
              }
            /> */}
            {/*<Button*/}
            {/*  onClick={props.handleSharing}*/}
            {/*  text='Partager'*/}
            {/*  className='cartetp-organism-button cartetp-organism-button__partage-width cartetp-organism-button__partage-margin'*/}
            {/*/>*/}
            <div className="cartetp-button-download-container">
              <Button
                onClick={props.download}
                style={{ justifyContent: 'center', alignItems: 'center' }}
                text='Télécharger'
                className='cartetp-organism-button cartetp-organism-button__download-width cartetp-organism-button__partage-margin'
              />
            </div>
            <div className='cartetp-header-container carte-telecharger-text'>
              Pour consulter vos garanties,{' '}
              <Link to='/Garanties'>
                <span className='cartetp-telecharger-bold'>
                  téléchargez votre tableau
                </span>
              </Link>
            </div>
            {/* <div className='cartetp-organism-check-container'>
              <div className='organism-cartetp-checkbox-content'>
                {/* <Checkbox
                  type='checkbox'
                  classNameContainer='organism-cartetp-checkbox-container'
                  label='Je souhaite recevoir ma carte de tp par courrier papier (à l’adresse indiquée sur mon profil)'
                  className='organism-cartetp-checkbox'
                  size={16}
                  onClick={props.checkBoxClicked}
                  checked={props.check}
                />
              </div>
              {props.check && (
                <>
                  <Button
                    text='Valider'
                    className='cartetp-organism-button cartetp-organism-button-validate'
                    onClick={props.validateClicked}
                    disabled={props.validate}
                  />
                  {props.validate && (
                    <Text
                      text='La demande a bien été envoyée.'
                      className='cartetp-organism-validate-text'
                    />
                  )}
                </>
              )}
            </div> */}
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default OrganismCarteTp;
